<template>
    <div class="col-md-12 mb-3 sb-news-block">
        <a tabindex="200" id="umrbtn" v-if="checkProvider('UMR')" href="#" @click.prevent="ssoClickNew('umr')" :class="hrefDisabled=='umr'?'btn btn-block btn-outline-success btn-outline-success-crbg disabled':'btn btn-block btn-outline-success btn-outline-success-crbg'">
            {{btnText['umr']}}
        </a>
        <a tabindex="205" id="uhcbtn" v-if="checkProvider('UHC')" href="#" @click.prevent="ssoClickNew('uhc')" :class="hrefDisabled=='uhc'?'btn btn-block btn-outline-success btn-outline-success-crbg disabled':'btn btn-block btn-outline-success btn-outline-success-crbg'">
            {{btnText['uhc']}}
        </a>
        <a tabindex="210" id="uhcfapbtn" v-if="checkProvider('UHC')" target="_blank" href="https://retiree.uhc.com/compassrose/find-a-provider" class="btn btn-block btn-outline-success btn-outline-success-crbg" title="Redirect to uhc.com">
            Find a Provider
        </a>
        <a tabindex="215" id="umrfapbtn" v-if="checkProvider('UMR')" target="_blank" role="link" @click.prevent="ssoClickNew('umr', 'findaprovider')" :class="hrefDisabled=='umr'?'btn btn-block btn-outline-success btn-outline-success-crbg disabled':'btn btn-block btn-outline-success btn-outline-success-crbg'" title="Redirect to umr.com">
            Find a Provider
        </a>

        <a tabindex="220" id="optumrxbtn" v-if="envoptum !== 'off' && checkProvider('OptumRx')" href="#"
           @click.prevent="ssoClickNew('optumrx')"
           :class="hrefDisabled=='umr'?'btn btn-block btn-outline-success btn-outline-success-crbg disabled':'btn btn-block btn-outline-success btn-outline-success-crbg'"
        >{{btnText['optumrx']}}</a>
        <a tabindex="225" id="esibtn" v-if="checkProvider('ESI')" href="#" @click.prevent="ssoClickNew('esi', 'locatepharmacy')" :class="hrefDisabled=='esi'?'btn btn-block btn-outline-success btn-outline-success-crbg disabled':'btn btn-block btn-outline-success btn-outline-success-crbg'">
            {{btnText['esi']}}
        </a>
        <a
            v-if="showDODSsoButton()"
            tabindex="230"
            id="dodbtn"
            class="btn btn-block btn-outline-success btn-outline-success-crbg"
            title=""
            href="https://doctorondemand.com/microsite/compassrose/"
            target="_blank"
        >
            Doctor On Demand
        </a>
        <a
            v-if="showIHSsoButton()"
            tabindex="235"
            id="ih_btn"
            class="btn btn-block btn-outline-success btn-outline-success-crbg"
            title=""
            href="https://includedhealth.com/microsite/compassrose/"
            target="_blank"
        >
            Included Health
        </a>
        <a href="#"
           v-if="false && showLinkButton('sword-health')"
           @click.prevent="ssoClickNew('sword')"
           tabindex="240"
           :class="hrefDisabled=='umr'?'btn btn-block btn-outline-success btn-outline-success-crbg disabled':'btn btn-block btn-outline-success btn-outline-success-crbg'"
        >{{btnText['sword']}}</a>
        <a tabindex="245" id="vvdbtn" v-if="showDialCareSso" @click.prevent="invokeDialCareSSO()" href="" target="_blank" class="btn btn-block btn-outline-success btn-outline-success-crbg" title="DialCare SSO">
            Virtual Vet (DialCare)
        </a>
        <a v-if="showLivingWell()" tabindex="250" id="lwbtn" href="https://www.compassrosebenefits.com/programs/living-well" target="_blank"
           class="btn btn-block btn-outline-success btn-outline-success-crbg" title="Living Well Program">
            Living Well Program
        </a>
        <a tabindex="255" id="hlbtn" v-if="speciality==='N' && contentProvider==='emmi' && false" href="/searchable-health-library" class="btn btn-block btn-outline-success btn-outline-success-crbg" title="Redirect to Library Page">
            Health Library
        </a>
        <a tabindex="260" id="rtccbtn" href="/coverage-request/Coverage" v-if="canSeeChangeForm()" class="btn btn-block btn-outline-success btn-outline-success-crbg" title="Redirect to Coverage Page">
            Request to Change Coverage
        </a>
<!--        <a v-if="beneficiaryPlans.length === 1" :href="beneficiaryPlans[0].link" class="btn btn-block btn-outline-success btn-outline-success-crbg" title="Redirect to Beneficiary Page">-->
<!--            Update Beneficiary-->
<!--        </a>-->
        <a tabindex="265" id="ubbtn" v-if="beneficiaryPlans.length > 0" href="#" class="btn btn-block btn-outline-success btn-outline-success-crbg" title="Redirect to Beneficiary Page" data-toggle="modal" data-target="#beneficiaryModal">
            Update Beneficiary
        </a>
        <div v-if="showwellnessrewards">
            <div v-if="checkProvider('UMR') && isHigh()">
                <a id="wrpbtn" tabindex="270" v-if="wellnessrewardssitecontentid" :href="'wellness-rewards/'" class="btn btn-block btn-outline-success btn-outline-success-crbg" title="Wellness Rewards Program">
                    Wellness Rewards Program
                </a>
            </div>
        </div>

        <div id="sso" v-html="sso" ref="sso"></div>

        <div class="modal fade" id="beneficiaryModal" tabindex="-1" role="dialog" aria-labelledby="beneficiaryModalLabel"
             aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="beneficiaryModalLabel">Select Your Plan</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <a v-for="bp in beneficiaryPlans" :href="bp.link" class="btn btn-block btn-outline-success btn-outline-success-crbg" title="Redirect to Beneficiary Page" target="_blank" @click="modalHide">
                            {{ bp.name }}
                        </a>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "SBDashboardLinks",
    props: [
        'healthPlans',
        'speciality',
        'legacy_medicare',
        'contentProvider',
        'wellnessrewardssitecontentid',
        'showwellnessrewards',
        'userovereighteen',
        'envoptum',
        'ip',
        'dailcareTermination'
    ],
    data() {
        return {
            dialCareSSORoute: '/api/dialcare-sso/',
            errorResponse: {},
            userAgent: '',
            sso: '',
            ssoData: '',
            btnText:{
                umr:'Go to UMR',
                uhc:'Go to UHC',
                esi: 'Find a Pharmacy',
                optumrx: 'Go to Optum Rx',
                sword: 'Go to Sword Health'
            },
            hrefDisabled:'',
            beneficiaryPlans: this.healthPlans.healthplans== undefined?{}:this.healthPlans.healthplans.map(hp => {
                return {
                    name: hp.planname,
                    link: hp.hpd_fb.find(fb => fb.name === 'Update Beneficiary')?.value
                }
            }).filter(hp => hp.link && hp.name === "Group Accident Plan"),
        };
    },
    mounted() {
        this.userAgent = navigator.userAgent;
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if(urlParams.get('provider')!==null){
            this.ssoClick(urlParams.get('provider'),urlParams.get('path'))
        }
    },
    computed: {
        showDialCareSso() {
            // Hide if date/time passed
            if (this.dailcareTermination && new Date() >= new Date(this.dailcareTermination)) {
                return false;
            }
            if(!this.userovereighteen) {
                return false;
            }
            if(this.speciality !== 'N') {
                return false;
            }
            return !!this.healthPlans.healthplans.find(
                hp => (
                    hp.groupnum === '76411449-Has Medicare Part B' ||
                    hp.groupnum === '76411449- No Medicare' ||
                    hp.groupnum === '76411449- No Medicare' ||
                    hp.groupnum === '76411449- Standard'
                )
            );
        },
    },
    methods: {
        invokeDialCareSSO() {
            this.$http.get(this.dialCareSSORoute).then(function(response) {
                    if (response.body && response.body.trim() !== "") {
                        window.open(response.body, '_blank');
                    }else{
                        console.error("SSO Failed.");
                        this.errorResponse = "SSO Failed.";
                    }
            }, (response) => {
                this.errorResponse = response;
            })
        },
        isSafariIOS() {
            return (
                /iPad|iPhone|iPod/.test(this.userAgent) &&
                !window.MSStream &&
                /Safari/.test(this.userAgent)
            );
        },
        ssoClickNew(provider, path){
            if (provider.toLowerCase() === 'esi') {
                // Open Express Scripts URL for 'esi' provider
                window.open('https://www.express-scripts.com', '_blank');
            } else {
                window.open(window.location.href + '?provider=' + provider + '&path=' + path, '_blank');
            }
        },
        ssoClick(provider, path) {
            this.hrefDisabled=provider;
            const oldText=this.btnText[provider];
            this.btnText[provider]='Loading...'
            document.getElementById("overlay").style.display = "flex";
            axios
                .get('/api/sso/' + provider + (path ? ('/' + path) : ''))
                .then(res => {
                    this.sso = res.data.html;
                }).then(() => {
                    // if(!this.isSafariIOS()){
                    //     this.$refs.sso.children[3].target = '_blank';
                    // }
                this.$refs.sso.children[3].submit();
                }).finally(() => {
                    this.btnText[provider]=oldText;
                    document.getElementById("overlay").style.display = "none";
                    this.hrefDisabled='';
                });
        },
        checkProvider(provider) {
            if(this.healthPlans.healthplans==undefined)
                return false;
            if(this.healthPlans.elig==undefined || this.healthPlans.elig.status==false)
                return false;
            if(this.healthPlans.elig.memberdata!==undefined && this.healthPlans.elig.memberdata['sso_flag'].includes('5') &&  provider==='UMR')
                return false;
            // if(this.healthPlans.elig.memberdata!==undefined && ['UMR','UHC'].includes(provider))
            //     return true;
            return !!this.healthPlans.healthplans.find(hp => hp.provider === provider);
        },
        canSeeChangeForm(){
            if(this.healthPlans.healthplans==undefined) {
                return false;
            }

            // if(!!this.healthPlans.healthplans.find(hp => hp.planname=='UBLIC (Retiree)') && this.healthPlans.healthplans.length==1)
            //     return false;
            // else
            //     return true;

            return !!this.healthPlans.healthplans.find(hp => hp.planname === 'Group Accident Plan');
        },
        modalHide() {
            $('#beneficiaryModal').modal('hide')
        },
        showLinkButton(button) {
            switch(button) {
                case 'sword-health':
                    return false;
                    // return this.healthPlans.healthplans.find(hp => hp.groupnum == '76411449- No Medicare');
            }

        },
        ssoSPInitiateClicked(serviceProvider) {
            axios.post(`/api/cache-user-session`).then((res) => {
                if (res.status === 200) {
                    let url = null;

                    // for local test POST handle-authn-request
                    // url = `/sso-sp/initiate?service_provider=${serviceProvider}`;

                    if (serviceProvider === 'crbg-doctorsondemand') {
                        url = process.env.MIX_SSO_DOD_START_URL;
                    } else if (serviceProvider === 'crbg-includedhealth') {
                        url = process.env.MIX_SSO_IH_START_URL;
                    }

                    if (url) window.open(url, '_blank');
                }
            });
        },
        showDODSsoButton() {
            return this.speciality === 'N' && this.userovereighteen === '1'
                && (process.env.MIX_SHOW_SSO_DOD_IH_BUTTONS === 'true' || this.ip === process.env.MIX_VPN_IP)
                && this.healthPlans.healthplans.find(
                    hp => hp.groupnum.includes('76411449- No Medicare')
                        || hp.groupnum.includes('76411449- Standard')

            );
        },
        showIHSsoButton() {
            return this.speciality === 'N' && this.userovereighteen === '1'
                && (process.env.MIX_SHOW_SSO_DOD_IH_BUTTONS === 'true' || this.ip === process.env.MIX_VPN_IP)
                && this.healthPlans.healthplans.find(
                    hp => hp.groupnum.includes('76411449- No Medicare')
            );
        },
        isHigh(){
            return this.healthPlans.healthplans.find(
                hp => hp.groupnum.includes('76411449- No Medicare')
            );
        },
        showLivingWell(){
            return this.healthPlans.healthplans.find(
                hp => hp.groupnum.includes('76411449- No Medicare - 2024')
                    || hp.groupnum.includes('76411449- Standard')
            );
        }
    }
}
</script>

<style scoped>

</style>
